// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__R0Nms","spin":"Loader_spin__chpkr","sm":"Loader_sm__C7zLg","md":"Loader_md__LKq1u","lg":"Loader_lg__zsLlK"};